/**
 * Minimal "no access" screen — shown when an authed user has no memberships
 * or no grant in any accepted domain.
 */
import { useAuth } from './useAuth'

export function NoAccessScreen() {
  const { logout, memberships } = useAuth()
  const hasOrgs = memberships.length > 0
  return (
    <div
      role="alert"
      className="flex h-dvh flex-col items-center justify-center gap-4 p-6 text-center"
      data-testid="cerberus-no-access"
    >
      <h1 className="text-lg font-semibold">Sem acesso</h1>
      <p className="text-sm text-muted max-w-md">
        {hasOrgs
          ? 'Sua conta esta autenticada, mas nao tem permissoes (grants) em nenhum modulo desta aplicacao. Fale com o administrador da sua organizacao.'
          : 'Sua conta esta autenticada, mas nao esta vinculada a nenhuma organizacao. Fale com o administrador.'}
      </p>
      <button
        type="button"
        onClick={logout}
        className="rounded border border-default px-3 py-1 text-sm"
      >
        Sair
      </button>
    </div>
  )
}
